var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewHouse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 300 300",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M232.258,48.387l-43.548,0l-0,-9.677c-0,-2.676 -2.163,-4.839 -4.839,-4.839l-14.516,-0l-0,-33.871l-9.678,0l0,5.226c-14.801,2.134 -26.511,13.843 -28.645,28.645l-5.226,-0c-2.675,-0 -4.838,2.163 -4.838,4.839l-0,9.677l-4.839,0c-2.676,0 -4.839,2.163 -4.839,4.839l0,72.58l-9.677,0l-0,-29.032l-9.678,0l0,29.032l-4.838,0c-2.676,0 -4.839,2.163 -4.839,4.839l0,14.516l-4.839,0c-2.675,0 -4.838,2.163 -4.838,4.839l-0,14.516l-4.839,0c-2.676,0 -4.839,2.163 -4.839,4.839l0,125.806c0,2.676 2.163,4.839 4.839,4.839l164.516,0c2.676,0 4.839,-2.163 4.839,-4.839l-0,-241.935c-0,-2.676 -2.163,-4.839 -4.839,-4.839Zm-72.581,-33.382l0,18.866l-18.866,-0c1.931,-9.465 9.402,-16.936 18.866,-18.866Zm-29.032,28.543l48.387,0l0,4.839l-48.387,0l0,-4.839Zm-38.71,91.936l19.355,-0l0,9.677l-19.355,0l0,-9.677Zm-9.677,19.355l29.032,-0l0,9.677l-29.032,0l0,-9.677Zm48.387,135.484l-29.032,-0l-0,-9.678l29.032,0l0,9.678Zm29.032,-0l-19.354,-0l-0,-14.517c-0,-2.675 -2.163,-4.838 -4.839,-4.838l-38.71,-0c-2.676,-0 -4.839,2.163 -4.839,4.838l0,14.517l-19.354,-0l-0,-116.129l87.096,-0l0,116.129Zm0,-125.807l-19.354,0l-0,-9.677l19.354,-0l0,9.677Zm67.742,125.807l-58.064,-0l-0,-140.323c-0,-2.676 -2.163,-4.839 -4.839,-4.839l-29.032,0c-2.676,0 -4.839,2.163 -4.839,4.839l0,14.516l-9.677,0l-0,-106.451l106.451,-0l0,232.258Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.484,135.484l29.032,-0c2.676,-0 4.839,-2.163 4.839,-4.839l-0,-19.355c-0,-2.675 -2.163,-4.838 -4.839,-4.838l-29.032,-0c-2.676,-0 -4.839,2.163 -4.839,4.838l0,19.355c0,2.676 2.163,4.839 4.839,4.839Zm4.839,-19.355l19.354,0l0,9.677l-19.354,0l-0,-9.677Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.484,96.774l29.032,0c2.676,0 4.839,-2.163 4.839,-4.839l-0,-19.354c-0,-2.676 -2.163,-4.839 -4.839,-4.839l-29.032,-0c-2.676,-0 -4.839,2.163 -4.839,4.839l0,19.354c0,2.676 2.163,4.839 4.839,4.839Zm4.839,-19.355l19.354,0l0,9.678l-19.354,-0l-0,-9.678Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.871,96.774l29.032,0c2.676,0 4.839,-2.163 4.839,-4.839l-0,-19.354c-0,-2.676 -2.163,-4.839 -4.839,-4.839l-29.032,-0c-2.676,-0 -4.839,2.163 -4.839,4.839l0,19.354c0,2.676 2.163,4.839 4.839,4.839Zm4.839,-19.355l19.355,0l-0,9.678l-19.355,-0l-0,-9.678Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.871,135.484l29.032,-0c2.676,-0 4.839,-2.163 4.839,-4.839l-0,-19.355c-0,-2.675 -2.163,-4.838 -4.839,-4.838l-29.032,-0c-2.676,-0 -4.839,2.163 -4.839,4.838l0,19.355c0,2.676 2.163,4.839 4.839,4.839Zm4.839,-19.355l19.355,0l-0,9.677l-19.355,0l-0,-9.677Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.871,174.194l29.032,-0c2.676,-0 4.839,-2.163 4.839,-4.839l-0,-19.355c-0,-2.676 -2.163,-4.839 -4.839,-4.839l-29.032,0c-2.676,0 -4.839,2.163 -4.839,4.839l0,19.355c0,2.676 2.163,4.839 4.839,4.839Zm4.839,-19.355l19.355,-0l-0,9.677l-19.355,0l-0,-9.677Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.871,212.903l29.032,0c2.676,0 4.839,-2.163 4.839,-4.838l-0,-19.355c-0,-2.676 -2.163,-4.839 -4.839,-4.839l-29.032,-0c-2.676,-0 -4.839,2.163 -4.839,4.839l0,19.355c0,2.675 2.163,4.838 4.839,4.838Zm4.839,-19.355l19.355,0l-0,9.678l-19.355,-0l-0,-9.678Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.871,251.613l29.032,-0c2.676,-0 4.839,-2.163 4.839,-4.839l-0,-19.355c-0,-2.675 -2.163,-4.838 -4.839,-4.838l-29.032,-0c-2.676,-0 -4.839,2.163 -4.839,4.838l0,19.355c0,2.676 2.163,4.839 4.839,4.839Zm4.839,-19.355l19.355,0l-0,9.677l-19.355,0l-0,-9.677Z",
    style: {
      fillRule: "nonzero"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 82.258,
    y: 183.871,
    width: 9.677,
    height: 9.677
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 101.613,
    y: 183.871,
    width: 9.677,
    height: 9.677
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 120.968,
    y: 183.871,
    width: 9.677,
    height: 9.677
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 140.323,
    y: 183.871,
    width: 9.677,
    height: 9.677
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 82.258,
    y: 203.226,
    width: 9.677,
    height: 9.677
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 101.613,
    y: 203.226,
    width: 9.677,
    height: 9.677
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 120.968,
    y: 203.226,
    width: 9.677,
    height: 9.677
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 140.323,
    y: 203.226,
    width: 9.677,
    height: 9.677
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 82.258,
    y: 222.581,
    width: 9.677,
    height: 9.677
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 101.613,
    y: 222.581,
    width: 9.677,
    height: 9.677
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 120.968,
    y: 222.581,
    width: 9.677,
    height: 9.677
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 140.323,
    y: 222.581,
    width: 9.677,
    height: 9.677
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 82.258,
    y: 241.935,
    width: 9.677,
    height: 9.677
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 101.613,
    y: 241.935,
    width: 9.677,
    height: 9.677
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 120.968,
    y: 241.935,
    width: 9.677,
    height: 9.677
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 140.323,
    y: 241.935,
    width: 9.677,
    height: 9.677
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewHouse);
export default __webpack_public_path__ + "static/media/new_house.577cb7b7.svg";
export { ForwardRef as ReactComponent };